<template>
    <v-card
        elevation="0"
        height="100%"
        :class="[priority]"
        class="d-flex flex-column justify-space-between pa-0"
    >
        <v-card-title
            v-if="item.title"
            :class="[priority]"
            class="flex-nowrap align-center"
        >
            <v-icon
                v-if="icon"
                large
                :class="[priority]"
                class="mr-4"
                v-text="icon"
            />
            <span>
                {{ item.title }}
            </span>
        </v-card-title>
        <v-card-text v-html="body" class="flex-grow-1 flex-shrink-1" />
        <div id="button-bar" class="d-flex justify-end flex-grow-0">
            <v-btn
                v-for="(link, i) of item.links"
                @click="redirect(link.target)"
                small
                :color="colour"
                :key="i"
                class="mb-2 mr-2"
                >{{ link.text || 'Go' }}</v-btn
            >
        </div>
    </v-card>
</template>

<script>
import marked from 'marked'

export default {
    name: 'MessageItem',
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    computed: {
        priority() {
            return this.item.priority ? `${this.item.priority}-priority` : null
        },
        icon() {
            if (this.item.priority === 'high') {
                return 'mdi-bullhorn'
            } else if (this.item.priority === 'medium') {
                return 'mdi-alert-outline'
            } else {
                return null
            }
        },
        colour() {
            if (this.item.priority === 'high') {
                return 'error'
            } else if (this.item.priority === 'medium') {
                return 'accent'
            } else {
                return null
            }
        },
        body() {
            return marked(this.item.body)
        },
    },
    methods: {
        redirect(target) {
            if (!target.startsWith('http')) {
                target = `https://${target}`
            }
            let targetUrl = new URL(target)
            window.open(targetUrl, '_blank')
        },
    },
}
</script>

<style scoped>
.v-card__title.high-priority {
    color: var(--v-error-base);
}
.v-icon.high-priority {
    color: var(--v-error-base);
}

.v-card__title.medium-priority {
    color: var(--v-accent-base);
}
.v-icon.medium-priority {
    color: var(--v-accent-base);
}

.v-card__title.normal-priority {
    color: var(--v-primary-base);
}
.v-card__title > span {
    word-break: break-word;
}

div.v-card__text {
    white-space: pre-wrap;
    overflow-x: hidden;
    overflow-y: auto;
    mask-image: linear-gradient(180deg, #000 80%, transparent);
}
div#button-bar {
    position: absolute;
    bottom: 0;
    right: 0;
}
</style>
